/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { findIndexById } from "common/utils/helpers/find-index-by-id";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import CheckBox from "components/jiffy/react-check-box/CheckBox.vue";
import { api } from "jiffy-api";
import debounce from "lodash.debounce";
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useEffect, useRef, useState } from "react";
import { cn } from "tailwind-variants";
import RemoveBackground from "./ArtworkQualityConfigPanel/components/RemoveBackground.vue";
import { useSpanglesStore } from "./spangles-module";
import { useStickersStore } from "./stickers-module";
import { useDtfStore } from "./store";
import { hasGangSheetError } from "./utils";
import "./TrimInfo.scss";

const REMOVE_BACKGROUND_SWITCH_DEBOUNCE = 3000;

export default function TrimInfo({
  toggleBackgroundError = null,
  removeBackground = true,
  defaultRemoveBackground = true,
  canRemoveBg = false,
  id,
  paddingSize = "no_padding",
  artwork = null,
  activeConfigSection = null,
  ...restProps
}: any) {
  // @ts-expect-error TS(6133): 'backgroundRemovedSwitch' is declared but its valu... Remove this comment to see the full error message
  const [backgroundRemovedSwitch, setBackgroundRemovedSwitch] = useState(true);
  const [userForceBgRemove, setUserForceBgRemove] = useState(false);
  // @ts-expect-error TS(6133): 'setAnnotateMode' is declared but its value is nev... Remove this comment to see the full error message
  const [annotateMode, setAnnotateMode] = useState("keep");

  const dtfStore = useDtfStore();
  const stickersStore = useStickersStore();
  const spanglesStore = useSpanglesStore();

  function sticker() {
    // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
    return dtfStore.sticker;
  }

  function allowForceBgRemove() {
    // @ts-expect-error TS(4111): Property 'allowForceBgRemove' comes from an index ... Remove this comment to see the full error message
    return dtfStore.allowForceBgRemove;
  }

  function productId() {
    // @ts-expect-error TS(4111): Property 'productId' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.productId;
  }

  // @ts-expect-error TS(6133): 'experiments' is declared but its value is never r... Remove this comment to see the full error message
  function experiments() {
    // @ts-expect-error TS(4111): Property 'experiments' comes from an index signatu... Remove this comment to see the full error message
    return dtfStore.experiments;
  }

  function isProColor() {
    // @ts-expect-error TS(4111): Property 'isProColor' comes from an index signatur... Remove this comment to see the full error message
    return dtfStore.isProColor;
  }

  function isSpangle() {
    // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.isSpangle;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return dtfStore.isStandardArtwork;
  }

  function enableAbAiMonetization() {
    // @ts-expect-error TS(4111): Property 'enableAbAiMonetization' comes from an in... Remove this comment to see the full error message
    return dtfStore.enableAbAiMonetization;
  }

  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return dtfStore.artworks;
  }

  function businessLine() {
    // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
    return dtfStore.businessLine;
  }

  function enableBackgroundRemovalToggle() {
    return isStandardArtwork() ? artwork?.enhancementCompleted : true;
  }

  function hasGangSheetErrorLocal() {
    return hasGangSheetError(artwork);
  }

  // @ts-expect-error TS(6133): 'annotateEnabled' is declared but its value is nev... Remove this comment to see the full error message
  function annotateEnabled() {
    return artwork?.annotateEnabled;
  }

  // @ts-expect-error TS(6133): 'undoEnabled' is declared but its value is never r... Remove this comment to see the full error message
  function undoEnabled() {
    const { revisionImageUrls = [], revisionPosition = 0 } = artwork || {};
    return revisionPosition > 0 && revisionImageUrls[revisionPosition - 1] !== undefined;
  }

  // @ts-expect-error TS(6133): 'redoEnabled' is declared but its value is never r... Remove this comment to see the full error message
  function redoEnabled() {
    const { revisionImageUrls = [], revisionPosition = 0 } = artwork || {};
    return (
      revisionPosition < revisionImageUrls.length - 1 &&
      revisionImageUrls[revisionPosition + 1] !== undefined
    );
  }

  function updateArtworkStyle(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateArtworkStyle(...args);
  }

  function sendUpdateArtworkStyle(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.sendUpdateArtworkStyle(...args);
  }

  // @ts-expect-error TS(6133): 'loadArtworkAndSetPaddingImage' is declared but it... Remove this comment to see the full error message
  function loadArtworkAndSetPaddingImage(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.loadArtworkAndSetPaddingImage(...args);
  }

  function generateCmykImages(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.generateCmykImages(...args);
  }

  function generateSpangleImage(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.generateSpangleImage(...args);
  }

  function updateArtworkValuesById(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateArtworkValuesById(...args);
  }

  function setPendingPinningInvalidation(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setPendingPinningInvalidation(...args);
  }

  // @ts-expect-error TS(6133): 'preCut' is declared but its value is never read.
  function preCut() {
    // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
    return dtfStore.preCut;
  }

  function generateStickerImage(...args: any[]) {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    return stickersStore.generateStickerImage(...args);
  }

  function resetSpangles(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return spanglesStore.resetSpangles(...args);
  }

  const updateToggleBackgroundRef = useRef(null);

  useEffect(() => {
    // @ts-expect-error TS(2322): Type 'DebouncedFunc<(removed: any) => void>' is no... Remove this comment to see the full error message
    updateToggleBackgroundRef.current = debounce(removed => {
      const paddingSizeValue = artwork?.paddingSize || "no_padding";
      sendUpdateArtworkStyle({
        id,
        isBgRemoved: removed,
        padding_size: paddingSizeValue,
        forceBgRemoval: userForceBgRemove
      });
    }, REMOVE_BACKGROUND_SWITCH_DEBOUNCE);
  }, [id, artwork, userForceBgRemove, sendUpdateArtworkStyle]);

  useEffect(() => {
    handleAnnotateModeChange();
  }, [annotateMode]);

  useEffect(() => {
    if (activeConfigSection === "jiffy-print-perfect" && !removeBackground) {
      handleRemoveBackgroundChange(true);
    }
    // Only fire when activeConfigSection changes (matching the Vue watcher behavior).
    // Including removeBackground would revert the user's toggle immediately.
    // eslint-disable-next-line
  }, [activeConfigSection]);

  useEffect(() => {
    if (enableAbAiMonetization()) {
      if (activeConfigSection === "jiffy-print-perfect" && !removeBackground) {
        handleRemoveBackgroundChange(true);
      }
    }
  }, []);

  function handleRemoveBackgroundChange(arg: any) {
    const isManuallyToggled = typeof arg !== "boolean";
    const newValue = isManuallyToggled ? !removeBackground : arg;
    if (artwork?.pinningSessionId) {
      if (arg?.target) {
        arg.target.checked = removeBackground;
      }
      setPendingPinningInvalidation({
        type: "removeBackground",
        artworkId: artwork.id,
        value: newValue
      });
      return;
    }
    setTimeout(() => {
      executeRemoveBackgroundChange(newValue, isManuallyToggled);
    }, 0);
  }

  function executeRemoveBackgroundChange(isBgRemoved: any, isManuallyToggled = false) {
    setBackgroundRemovedSwitch(isBgRemoved);
    const artworkIndex = findIndexById(artworks(), id);
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const artworkAtIndex = artworks()[artworkIndex];
    if (isStandardArtwork() && !artworkAtIndex?.enhancementCompleted) {
      return;
    }
    submitDtfEvent("remove_background_toggled", {
      artwork_id: artwork.id,
      product_id: productId(),
      previous_state: removeBackground,
      new_state: isBgRemoved,
      active_config_section: activeConfigSection,
      business_line: businessLine(),
      is_manually_toggled: isManuallyToggled
    });
    resetSpangles();
    updateArtworkStyle({
      id,
      isBgRemoved
    });
    if (sticker()) {
      generateStickerImage({
        artwork,
        removeBackground: isBgRemoved
      });
    }
    // @ts-expect-error TS(2349): This expression is not callable.
    updateToggleBackgroundRef.current?.(isBgRemoved);
  }

  function handleManualBgRemoval(event: any) {
    setUserForceBgRemove(event.target.checked);
    handleRemoveBackgroundChange(event);
    submitDtfEvent("manual_bg_removal_toggle", {
      artwork
    });
  }

  // @ts-expect-error TS(6133): 'handleAnnotateClick' is declared but its value is... Remove this comment to see the full error message
  function handleAnnotateClick(value: any) {
    updateArtworkValuesById({
      id,
      annotateEnabled: value
    });
  }

  function handleAnnotateModeChange() {
    updateArtworkValuesById({
      id,
      annotateMode
    });
  }

  // @ts-expect-error TS(6133): 'segmentImage' is declared but its value is never ... Remove this comment to see the full error message
  async function segmentImage() {
    if (!artwork?.annotatedPoints || artwork.annotatedPoints.length === 0) return;
    const response = await api.dtf.segmentImage({
      id,
      points: artwork.annotatedPoints,
      canvas_width: artwork.annotatedCanvasWidth,
      canvas_height: artwork.annotatedCanvasHeight,
      product_id: productId()
    });
    if (isProColor()) {
      await generateCmykImages({
        artwork
      });
    }
    if (isSpangle()) {
      await generateSpangleImage({
        artwork
      });
    }
    const updatedAttributes = {
      url: response.image_url,
      metadata: response.metadata,
      revisionImageUrls: response.revision_image_urls,
      revisionPosition: response.revision_image_urls.length - 1,
      annotatedPoints: [],
      originalImageUrl: response.original_image_url,
      originalNoBgUrl: response.original_no_bg_url,
      stickerCutlineNoBgUrl: response.sticker_cutline_no_bg_url,
      stickerCutlineWithBgUrl: response.sticker_cutline_with_bg_url
    };
    updateArtworkValuesById({
      id,
      ...updatedAttributes
    });
    if (sticker()) {
      const updatedArtwork = {
        ...artwork,
        ...updatedAttributes
      };
      await generateStickerImage({
        artwork: updatedArtwork,
        useCache: false
      });
    }
  }

  // @ts-expect-error TS(6133): 'handleRevisionToggle' is declared but its value i... Remove this comment to see the full error message
  async function handleRevisionToggle(revisionType: any) {
    const { revisionPosition = 0 } = artwork || {};
    const newPosition = revisionType === "undo" ? revisionPosition - 1 : revisionPosition + 1;
    const response = await api.dtf.toggleSegmentVersion({
      id,
      position: newPosition,
      toggle_type: revisionType,
      product_id: productId()
    });
    if (isProColor()) {
      await generateCmykImages({
        artwork
      });
    }
    if (isSpangle()) {
      await generateSpangleImage({
        artwork
      });
    }
    const updatedAttributes = {
      url: response.image_url,
      metadata: response.metadata,
      revisionPosition: newPosition,
      originalImageUrl: response.original_image_url,
      originalNoBgUrl: response.original_no_bg_url,
      stickerCutlineNoBgUrl: response.sticker_cutline_no_bg_url,
      stickerCutlineWithBgUrl: response.sticker_cutline_with_bg_url
    };
    updateArtworkValuesById({
      id,
      ...updatedAttributes
    });
    if (sticker()) {
      const updatedArtwork = {
        ...artwork,
        ...updatedAttributes
      };
      await generateStickerImage({
        artwork: updatedArtwork,
        useCache: false
      });
    }
  }

  return (
    <div {...restProps} className={cn("trim-info scope-d9968961", restProps.className)}>
      {isStandardArtwork() ? (
        <>
          {enableAbAiMonetization() && canRemoveBg && !hasGangSheetErrorLocal() ? (
            <RemoveBackground
              className={cn("scope-d9968961", {
                "trim-info__remove-toggle--disabled": !enableBackgroundRemovalToggle()
              })}
              value={removeBackground}
              disabled={!enableBackgroundRemovalToggle()}
              onChange={handleRemoveBackgroundChange}
              data-testid="remove-background"
            />
          ) : canRemoveBg && !hasGangSheetErrorLocal() ? (
            <button
              className={cn("trim-info__remove-toggle scope-d9968961", {
                "trim-info__remove-toggle--selected": removeBackground,
                "trim-info__remove-toggle--disabled": !enableBackgroundRemovalToggle()
              })}
              type="button"
              onClick={handleRemoveBackgroundChange}
              data-testid="trim-info-remove-toggle"
            >
              <UseSvg
                className="trim-info__remove-toggle-icon scope-d9968961"
                icon="check"
                data-testid="trim-info-remove-toggle-icon"
              />

              <span className="trim-info__remove-toggle-label scope-d9968961">
                Remove Background
              </span>
            </button>
          ) : null}
        </>
      ) : !isStandardArtwork() ? (
        <>
          {canRemoveBg && !hasGangSheetErrorLocal() ? (
            <CheckBox
              className="scope-d9968961"
              label="Remove Background"
              style={"gray"}
              disable={!enableBackgroundRemovalToggle()}
              data-testid="check-box"
            >
              <input
                className="scope-d9968961"
                type="checkbox"
                checked={removeBackground}
                disabled={!enableBackgroundRemovalToggle()}
                onChange={handleRemoveBackgroundChange}
                data-testid="trim-info-input"
              />
            </CheckBox>
          ) : null}
        </>
      ) : allowForceBgRemove() ? (
        <CheckBox
          className="scope-d9968961"
          label="Remove Background"
          style={"gray"}
          disabled={!enableBackgroundRemovalToggle()}
          data-testid="check-box-1"
        >
          <input
            className="scope-d9968961"
            type="checkbox"
            checked={userForceBgRemove}
            disabled={!enableBackgroundRemovalToggle()}
            onChange={handleManualBgRemoval}
            data-testid="trim-info-input-1"
          />
        </CheckBox>
      ) : null}
      {toggleBackgroundError ? (
        <div className="trim-info__wrapper trim-info__wrapper--error scope-d9968961">
          <UseSvg
            className="trim-info__icon scope-d9968961"
            icon="warning"
            data-testid="trim-info-icon"
          />

          <span className="scope-d9968961">{toggleBackgroundError}</span>
        </div>
      ) : null}
    </div>
  );
}
